import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;

  h1 {
    margin-bottom: 20px;
  }

  .showMore {
    width: 200px;
  }
`;

export const StoreCards = styled.div`
  -webkit-tap-highlight-color: transparent;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 20px 12px;
  justify-items: center;

  @media (max-width: 552px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .StoreCard {
    width: 100px;
    height: 100px;
  }

  .storecard{
    width: auto;
    height: auto;
    padding-right: 5px;
    padding-bottom: 5px;
  }

  @media (max-width: 1074px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 802px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 443px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 352px) {
    grid-template-columns: repeat(auto-fit, minmax(125px, 1fr));
  }

  button {
    width: 230px;
    height: 230px;

    @media (max-width: 515px) {
      height: 185px;
      width: 185px;
    }

    @media (max-width: 443px) {
      height: 150px;
      width: 150px;
    }

    @media (max-width: 351px) {
      height: 125px;
      width: 125px;
    }
  }
`;

export const AlignButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  margin-top: 12px;
`;
